export * from "./secondsPerMinute";
